
<template>
  <div>
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div v-for="(item,index) in list" :key="index" class="rect">
      <div class="image">
        <van-image
          width="4em"
          height="4em"
          :src="item.icon"
        />
      </div>
      <div class="title">
        {{ item.title }}
      </div>
      <div class="buttons">
        <van-button size="small" round plain hairline :color="GetColorMain()" type="danger" @click="onComment(item)">{{ item.isFirst?'评论晒单':'补充评论' }}</van-button>
      </div>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Image } from 'vant'
import TopBar from '@/components/TopBar'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Image.name]: Image,
    TopBar
  },
  data() {
    return {
      title: '评价晒单',
      backurl: '/my/index',
      list: [],
      orderId: undefined
    }
  },

  created() {
    this.orderId = this.$route.params.id
    this.init()
  },
  methods: {
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    init() {
      this.list = []
      request({
        url: '/StoreHelper/getCommentList',
        method: 'post',
        params: { orderId: this.orderId }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.list = response.data
      })
    },
    onComment(item) {
      this.$router.push('/store/orderComment/' + this.orderId + '?commodityId=' + item.commodityId + '&specificationMain=' + item.SpecificationMainId + '&specificationOther=' + item.SpecificationOtherIds)
    }
  }
}
</script>
<style scoped>
.rect{
  position: relative;
  background-color: #fff;
  padding: 0.5em;
  margin-bottom: 0.5em;
}
.rect .title{
  position: absolute;
  left:5em;
  top:0.5em;
  right: 0.5em;
    overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.rect .buttons{
  position: absolute;
  right: 0.5em;
  bottom: 1em;
}
</style>
